/**
 * Text utility functions for formatting and cleaning text content
 */

/**
 * Strip ALL HTML formatting and return only plain text
 * Removes all HTML tags, styles, attributes, and formatting
 *
 * @param html - HTML string to clean
 * @returns Plain text without any HTML formatting
 */
export const stripAllFormatting = (html: string): string => {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;

  // Extract only the plain text, without any HTML
  const plainText = tempDiv.textContent || tempDiv.innerText || '';

  // Return trimmed plain text
  return plainText.trim();
};

/**
 * Build a plain-text preview from an HTML string for list/preview UIs.
 *
 * Uses the DOM to strip tags AND decode HTML entities (e.g. &nbsp;, &amp;),
 * so previews never show raw entities like "&nbsp;". Collapses whitespace and
 * truncates with an ellipsis.
 *
 * @param html - HTML (or plain) string to preview
 * @param maxLength - max characters before truncating (default 150)
 * @returns clean, truncated plain-text preview
 */
export const htmlToPreviewText = (html: string, maxLength = 150): string => {
  if (!html) return '';

  // stripAllFormatting decodes entities (browser parses innerHTML) and removes tags.
  const clean = stripAllFormatting(html).replace(/\s+/g, ' ').trim();

  return clean.length > maxLength ? clean.substring(0, maxLength) + '...' : clean;
};
